import React, { Component } from "react";

class InterfaceCompatibility extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {" "}
        <h3>Compatibility</h3>
        <table style={{ width: "auto" }}>
          <tbody>
            <tr>
              <td className="b top">Page</td>
              <td className="b top">Support</td>
            </tr>
            <tr>
              <td className="b" style={{ paddingTop: 4 }}>
                Dashboard
              </td>
              <td style={{ textAlign: "center" }}>
                {this.props.dashboard === true ? (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }}
                  >
                    done
                  </i>
                ) : (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }}
                  >
                    close
                  </i>
                )}
              </td>
            </tr>
            <tr>
              <td className="b" style={{ paddingTop: 4 }}>
                Record
              </td>
              <td style={{ textAlign: "center" }}>
                {this.props.record === true ? (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }}
                  >
                    done
                  </i>
                ) : (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }}
                  >
                    close
                  </i>
                )}
              </td>
            </tr>
            <tr>
              <td className="b" style={{ paddingTop: 4 }}>
                Report
              </td>
              <td style={{ textAlign: "center" }}>
                {this.props.report === true ? (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }}
                  >
                    done
                  </i>
                ) : (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }}
                  >
                    close
                  </i>
                )}
              </td>
            </tr>
            <tr>
              <td className="b" style={{ paddingTop: 4 }}>
                Search
              </td>
              <td style={{ textAlign: "center" }}>
                {this.props.search === true ? (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }}
                  >
                    done
                  </i>
                ) : (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }}
                  >
                    close
                  </i>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default InterfaceCompatibility;



// WEBPACK FOOTER //
// ./src/components/Interface/InterfaceCompatibility.js